// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { ProductBrandStyles } from "@sc/Overrides/Components/ProductBrand";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import { color, ellipsis } from "@sc/XDL/Utilities";
import { css } from "styled-components";

interface ProductBrandVariantStyles {
    small?: ProductBrandStyles;
    medium?: ProductBrandStyles;
}

const sharedSmallTextStyles: TypographyProps = {
    size: "12px",
    lineHeight: "14px",
    weight: 400,
    css: css`
        &&& {
            width: auto;
            color: ${color("common.ui7")};
        }
        ${ellipsis(1)}
        ${wrapInContainerStyles}
    `,
};
const sharedMediumTextStyles: TypographyProps = {
    size: "14px",
    lineHeight: "22px",
    weight: "bold",
    css: css`
        width: auto;
        ${wrapInContainerStyles}
    `,
};

const productBrandVariantStyles: ProductBrandVariantStyles = {
    small: {
        nameText: {
            ...sharedSmallTextStyles,
            ...(TRANSLATE_OBJECT as any),
        },
        nameLink: {
            css: css`
                width: auto;
            `,
            typographyProps: {
                ...sharedSmallTextStyles,
                ...TRANSLATE_OBJECT,
                css: css`
                    ${sharedSmallTextStyles.css}
                    &:hover,
                    &:focus {
                        color: ${color("common.ui8")};
                    }
                `,
            },
        },
        wrapper: {
            css: css`
                width: 100%;
                display: flex;
            `,
        },
    },
    medium: {
        nameText: {
            ...sharedMediumTextStyles,
        },
        nameLink: {
            css: css`
                width: auto;
            `,
            typographyProps: {
                ...sharedMediumTextStyles,
                css: css`
                    ${sharedSmallTextStyles.css}
                    &&& {
                        color: ${color("text.link")};
                        &:hover,
                        &:focus {
                            color: ${color("common.ui8")};
                        }
                    }
                `,
            },
        },
        wrapper: {
            css: css`
                width: 100%;
                display: flex;
            `,
        },
    },
};

export default productBrandVariantStyles;
